// Client for the Knowledge Center (/api/knowledge). Sends the signed-in actor so progress is saved per employee ID.
import { headers, parse } from "./classificationApi";

const BASE = `${process.env.REACT_APP_BACKEND_URL}/api/knowledge`;
const get = (path) => fetch(`${BASE}${path}`, { headers: headers(null, false) }).then(parse);
const post = (path, body) => fetch(`${BASE}${path}`, { method: "POST", headers: headers(null, true), body: JSON.stringify(body) }).then(parse);

export const getTopic = (slug) => get(`/topics/${encodeURIComponent(slug)}`);
export const searchTopics = (q, tag) => get(`/search?${new URLSearchParams({ q: q || "", ...(tag ? { tag } : {}) })}`);
export const getGlossary = () => get("/glossary");
export const getProgress = () => get("/progress");
export const markViewed = (slug) => post("/progress/viewed", { slug });
export const checkAnswer = (slug, index, choice) => post(`/topics/${encodeURIComponent(slug)}/quiz/check`, { index, choice });
export const submitQuiz = (slug, answers) => post(`/topics/${encodeURIComponent(slug)}/quiz/submit`, { answers });

const indexPromises = {};
// The topic index is fixed per build and role — fetch once per role and share (help menu + Knowledge Center).
export function loadIndex() {
  const role = headers(null, false)["X-Actor-Role"] || "";
  if (!indexPromises[role]) indexPromises[role] = get("/index").catch(e => { delete indexPromises[role]; throw e; });
  return indexPromises[role];
}

export const fmtDay = (iso) => (iso ? new Date(`${iso}T00:00:00`).toLocaleDateString("en-PH", { day: "numeric", month: "short", year: "numeric" }) : "—");

// Which topic explains the screen at `pathname` (exact match, then its first segment).
export function topicForPath(index, pathname) {
  if (!index) return null;
  const p = pathname.startsWith("/learn") ? "/learn" : pathname;
  return index.pages[p] || index.pages[`/${p.split("/")[1]}`] || null;
}
